import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#selectable" }),
  /*#__PURE__*/_createTextVNode(" Selectable ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Used for node selection. ", -1)
const _hoisted_4 = { class: "rounded border p-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tree = _resolveComponent("el-tree")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_tree, {
        props: _ctx.props,
        load: _ctx.loadNode,
        lazy: "",
        "show-checkbox": "",
        onCheckChange: _ctx.handleCheckChange
      }, null, 8, ["props", "load", "onCheckChange"]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code2), 1)
        ]),
        _: 1
      })
    ])
  ]))
}